import { render, staticRenderFns } from "./SaveFile.vue?vue&type=template&id=40f7bc58&scoped=true&"
import script from "./SaveFile.vue?vue&type=script&lang=js&"
export * from "./SaveFile.vue?vue&type=script&lang=js&"
import style0 from "./SaveFile.vue?vue&type=style&index=0&id=40f7bc58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7bc58",
  null
  
)

export default component.exports